import type { AlcanceDeLimite, RangoPisado } from '../types/pricing-rules.types';

/**
 * Lote B2 (spec 246, punto 4; maqueta #b2-combinan): la estrategia propone, los
 * límites recortan y el redondeo termina. Del mismo tipo rige la regla más
 * específica (este producto > su marca o categoría > todo el catálogo), aunque
 * sea menos exigente; en el mismo escalón y entre tipos distintos se cumplen
 * todas y decide la más exigente. Lo decide el backend (`aplicarJerarquia`):
 * acá sólo se dice en palabras.
 */

/** Cómo se nombra, dentro de una frase, la regla que pisa a otra. */
export const LA_DE: Record<AlcanceDeLimite, string> = {
  PRODUCTO: 'la de este producto',
  MARCA_O_CATEGORIA: 'la de su marca o categoría',
  CATALOGO: 'la de todo el catálogo',
};

/** «no rige: decide «Colchones al 10 %», la de su marca o categoría, que es más específica». */
export function noRige(p: RangoPisado): string {
  return `no rige: decide «${p.pisadoPor.ruleName}», ${LA_DE[p.pisadoPor.alcance]}, que es más específica`;
}

/** El texto de siempre debajo de la barra, con la jerarquía. */
export const COMO_SE_COMBINAN =
  'De cada tipo rige la regla más específica; entre las que rigen, decide la más exigente. La estrategia pide un precio; queda el más cercano dentro del tramo verde.';
